import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";

import { motion } from "framer-motion";
import { client } from '../../utils/prismicHelpers';

//import Instagram from '../../static/icons/instagram.svg';
//import Linkedin from '../../static/icons/linkedin-2.svg';
//import Dribbble from '../../static/icons/dribbble.svg';

import { userInterface } from '../../utils/motionHelpers';

//const crypto = require("crypto");
//const valid_uid = crypto.randomBytes(20).toString('hex');

function svgLogo() {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 100 100">
            <g>
                <path d="M75.6,46.6c-0.8-1.1-1.7-2.2-2.8-3.3c-2-2-4-3.5-5.8-4.7c-0.4-0.2-0.8-0.5-1.2-0.7C56,32,49.5,21.3,49.5,9.1
    c0-2.4,0.2-4.7,0.7-6.9C39.7,7.9,32.6,19,32.6,31.8c0,2.4,0.3,4.8,0.8,7.1c0.6,2.7,1.5,5.2,2.6,7.6c-2.2,0.9-5.8,1.1-8.3-3.1
    c-0.2,0.2-0.4,0.4-0.6,0.6c-5.4,5.7-8.7,13.4-8.7,21.8c0,17.6,14.3,31.8,31.8,31.8c8.6,0,16.4-3.4,22.2-9c0.1-0.1,0.2-0.2,0.3-0.3
    c-7.5-7.5,0-15,0-15s4-3.3,5.9-10.3C80,58.5,80,52.6,75.6,46.6z"/>
            </g>
        </svg>
    )
}

const Navigation = () => {

    //console.log('Nav----')

    const [prismicNavdov, setPrismicNavdov] = useState({ navDoc: null });

    useEffect(() => {
        const fetchPrismicNavdov = async () => {
            try {
                const navDoc = await client.getSingle('navigation');
                if (navDoc) {
                    setPrismicNavdov({ navDoc });
                } else {
                    console.warn('Data not found');
                }
            } catch (error) {
                console.error(error);
            }
        }
        fetchPrismicNavdov();
    }, []);

    if (prismicNavdov.navDoc) {
        const navDoc = prismicNavdov.navDoc;

        //console.log(navDoc.data)

        return (
            <>
                <motion.div variants={userInterface} initial="hidden" animate="show" exit="exit" data-scroll-sticky className="ui">
                    <nav>
                        <div className="nav__logo">
                            <NavLink exact to="/" className="nav__item" activeClassName="nav__selected" aria-label={navDoc.data.logo.alt} alt={navDoc.data.logo.alt}>
                                {svgLogo()}
                            </NavLink>
                        </div>
                        <ul className="nav__group">
                            <li>
                                <NavLink to="/portfolio" className="nav__item" activeClassName="nav__selected">{navDoc.data.main_menu[0].portfolio}</NavLink>
                            </li>
                            <li>
                                <NavLink to="/about" className="nav__item" activeClassName="nav__selected">{navDoc.data.main_menu[0].about}</NavLink>
                            </li>
                        </ul>
                    </nav>
                </motion.div>
            </>
        );

    } else {
        return (<></>)
    }
};
export default Navigation;
/*
                <motion.div variants={userInterface} initial="hidden" animate="show" exit="exit" className="footer">
                    <div className="footer__wrapper">
                        <div className="footer__content">
                            <span className="">{`${navDoc.data.seo_description[0].text}`}</span>
                        </div>
                        <div className="footer__content__items">
                            <div className="network">
                                <a href="https://www.instagram.com/victorvergara.co/" target="_blank" rel="noreferrer">
                                    <img src={Instagram} alt="Logo instagram" width="20" height="20" />
                                </a>
                            </div>
                            <div className="network">
                                <a href="https://www.linkedin.com/in/victorvergaraux/" target="_blank" rel="noreferrer">
                                    <img src={Linkedin} alt="Logo Linkedin" width="20" height="20" />
                                </a>
                            </div>
                            <div className="network">
                                <a href="https://dribbble.com/victorvergara" target="_blank" rel="noreferrer">
                                    <img src={Dribbble} alt="Logo Dribbble" width="20" height="20" />
                                </a>
                            </div>
                        </div>
                    </div>
                </motion.div>

                */